import React, { Component } from 'react';

let _iTooltipsFactory = null;
let _tooltipKeyIndex = 0;
class TooltipsFactory extends Component {
    static initTooltip(tooltipClass, props = {}) {
        let key = `tooltip${_tooltipKeyIndex++}`;
        let fKey = Symbol();
        let tooltip = React.createElement(tooltipClass, Object.assign({}, {key: key, factoryKey: fKey}, props));
        let newTooltipsArray = this.state.tooltips;
        if (props.single === true) {
            newTooltipsArray = [];
        }
        newTooltipsArray.push(tooltip);
        this.setState({ tooltips: newTooltipsArray });
        return tooltip;
    }

    static destroyTooltip(factoryKey) {
        let newTooltipsArray = this.state.tooltips.filter((p)=>p.props.factoryKey!=factoryKey); // remove tooltip from array
        this.setState({ tooltips: newTooltipsArray });
    }

    static destroyAllTooltips() {
        this.setState({ tooltips: [] });
    }

    constructor(props) {
        super(props);
        this.state = {
            tooltips: []
        };
        TooltipsFactory.initTooltip = TooltipsFactory.initTooltip.bind(this); // external method of singleton
        TooltipsFactory.destroyTooltip = TooltipsFactory.destroyTooltip.bind(this); // external method of singleton
        TooltipsFactory.destroyAllTooltips = TooltipsFactory.destroyAllTooltips.bind(this); // external method of singleton
    }

    componentDidMount() {
        _iTooltipsFactory = this;
    }

    componentWillUnmount() {
        _iTooltipsFactory = null;
    }

    render() {
        return (
            <div id="tooltips-factory" className={this.state.tooltips.length > 0 ? 'has-tooltips' : ''}>
                { this.state.tooltips }
            </div>
        );
    }
}

export default TooltipsFactory;